import useNextGenHeader from "~/contexts/nextgen-header";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import { SearchExperience } from "./SearchExperience";

/** Full-page search, where the homepage's quick search sends "see all results". */
export const SearchPage = () => {
  useDocumentTitle("Search");
  useNextGenHeader({ title: "Search" });

  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-6">
      <SearchExperience />
    </div>
  );
};
